/**
 * @desc 导入工单数据文件
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.FreshdeskDataReportManageImportRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/freshdeskDataReportManage/import`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
